import { SubscriptionLinkedSubscriptions } from './subscription-linked-subscriptions'
import { Injectable } from '@angular/core'

@Injectable()
export class SubscriptionLinkedSubscriptionsSerializer {
  fromJson(json: any): SubscriptionLinkedSubscriptions {
    return json
  }

  toJson(
    subscriptionLinkedSubscriptions: SubscriptionLinkedSubscriptions
  ): any {
    return subscriptionLinkedSubscriptions
  }
}
